// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

		setTimeout(function() {
			$('.sprite .page-view .project:nth-child(odd)').addClass('pattern');
		}, 500);


		let BurgerMenu = document.getElementById('js_btn_menu');
		let NavigationBox = document.getElementById('navigationBox');
		let Body = document.body;
		let Header = document.getElementById('header');

		if(BurgerMenu){
			BurgerMenu.addEventListener('click', function(e){
				e.preventDefault();
				if(this.classList.contains("open")){
					this.classList.remove('open');
					NavigationBox.classList.remove('open');
					Body.classList.remove('scroll-no');
					Header.classList.remove('open');
					 // Header.classList.add('header-scroll');
					document.querySelectorAll('#logoHeader')[0].classList.remove('hidden');
					document.querySelectorAll('#headerRight')[0].classList.remove('hidden');

					if(document.querySelectorAll('#default')[0] != null){
						document.querySelectorAll('#default')[0].classList.remove('overflow-hidden');
					}
					if(document.querySelectorAll('#home')[0] != null){
						document.querySelectorAll('#home')[0].classList.remove('overflow-hidden');
					}
				} else {
					this.classList.add('open');
					NavigationBox.classList.add('open');
					Body.classList.add('scroll-no');
					Header.classList.add('open');
					// Header.classList.remove('header-scroll');
					document.querySelectorAll('#logoHeader')[0].classList.add('hidden');
					document.querySelectorAll('#headerRight')[0].classList.add('hidden');
					window.scrollTo(0, 0);
					
					if(document.querySelectorAll('#default')[0] != null){
						document.querySelectorAll('#default')[0].classList.add('overflow-hidden');
					}
					if(document.querySelectorAll('#home')[0] != null){
						document.querySelectorAll('#home')[0].classList.add('overflow-hidden');
					}

				}
			});
		}

	    // ------ Script Quad Accordion --------
		var accordionItems = document.querySelectorAll('.accordion__item');
		var i;
		for (i = 0; i < accordionItems.length; i++) {
			let disItem = accordionItems[i];
			let disBtn = disItem.querySelector('.accordion__btn');
			disBtn.addEventListener('click', function () {
				disItem.classList.toggle('open');

			});
		}
		//-------End Script Accordeon ---------

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};
	
}());

//START ANIMATION SVG Scroll
let item = document.getElementById("svg1");
if(item != undefined || item != null){
	item.addEventListener("load", function() {
		var doc = this.getSVGDocument();
		let svgItems = doc.querySelectorAll("path");
		svgItems.forEach(item => {
			if(item.classList.contains('cls-1')){
				let lengthWindow = 700;
				scrollComplete(item, lengthWindow)	
			}
		});
	});
}

function scrollComplete(item,lengthWindow ){
	const length = item.getTotalLength();
	item.style.strokeDasharray = length;
	item.style.strokeDashoffset = length;
	window.addEventListener("scroll", function () {
		// const scrollpercent = (document.body.scrollTop + document.documentElement.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
		let scrollpercent = (document.body.scrollTop + document.documentElement.scrollTop) / (lengthWindow);
		let draw = length * scrollpercent;
		item.style.strokeDashoffset = length - draw;
	});
}
//END ANIMATION SVG


function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}